import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Observable, map } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private readonly user: UserService,
    private readonly router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {

    return this.user.user$.pipe(
      map(userState => {
        // Already logged in?
        if (userState?.accessToken) {
          return true;
        }

        // Check localStorage fallback
        const stored = localStorage.getItem('lagesio_auth');
        if (stored) {
          const parsed = JSON.parse(stored);
          if (parsed?.accessToken) {
            // restore state
            this.user.restore(parsed);
            return true;
          }
        }

        // Redirect to login
        return this.router.parseUrl('/auth/login');
      })
    );
  }
}
